import { Component } from 'react';
import { ReactComponent as Clear } from 'assets/images/svg/clear.svg';
import { containsEmoji } from 'Helpers';

let timeout = null;

export default class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: false,
      inputError: false,
    };
  }

  handleInputChange = (event) => {
    clearTimeout(timeout);
    const { name, value } = event.target;
    const { condition = '', conditionVal = 0 } = this.props;

    // Check for emoji input
    if (containsEmoji(value)) {
      this.setState({ inputError: true, searchValue: false });
      return;
    }

    let isSearch = true;
    if (value !== '') {
      isSearch = condition ? value.length >= conditionVal : true;
    }

    if (isSearch) {
      const e = { target: { name, value } };
      timeout = setTimeout(() => {
        this.setState({ searchValue: !!value, inputError: false });
        this.props.dispatchFunction(e);
      }, 700);
    }
  };

  clear = () => {
    const { name } = this.props;
    document.getElementById(name).value = '';
    this.setState({ searchValue: false, inputError: false });
    const val = '';
    const searchObj = {
      target: {
        name: this.props.name,
        value: val,
      }
    };
    this.props.dispatchFunction(searchObj);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.refreshGridTime !== this.props.refreshGridTime && this.state.searchValue) {
      document.getElementById(this.props.name).value = '';
      this.setState({ searchValue: false, inputError: false });
    }
  }

  render() {
    const { inputError, searchValue } = this.state;

    return (
      <>
        <div>
          <input
            type='text'
            autoComplete='off'
            name={ this.props.name }
            placeholder='Search'
            onChange={ this.handleInputChange }
            id={ this.props.name }
            maxLength={ 255 }
          />
          { searchValue && (
            <span className="clear-search">
              <Clear onClick={ this.clear } />
            </span>
          ) }
          { inputError && (
            <span className='error'>Enter valid data</span>
          ) }
        </div>
      </>
    );
  }
}
